import { render } from "./AwardedQuoteDialog.vue?vue&type=template&id=52df0010&scoped=true"
import script from "./AwardedQuoteDialog.vue?vue&type=script&lang=js"
export * from "./AwardedQuoteDialog.vue?vue&type=script&lang=js"

import "./AwardedQuoteDialog.vue?vue&type=style&index=0&id=52df0010&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52df0010"]])

export default __exports__